export const SCROLL_EASE = 0.15;
export const FADE_ANIMATION_DELAY = 0.8;
export const BIG_TEXT_ANIMATION_DELAY = 0.5;
export const MOBILE_FADE_ANIMATION_DELAY = 0.4;
export const MOBILE_BIG_TEXT_ANIMATION_DELAY = 0.1;
export const FOCUSABLE_ELEMENT_SELECTORS = "a, button";
